// extracted by css-extract-rspack-plugin
export default {"popover":"II7NweFdd3ogvDHm"};